const Star = ({ filled }: { filled: boolean }) => (
  <svg viewBox="0 0 20 20" className={filled ? "" : "empty"} aria-hidden>
    <path
      d="M10 1.6l2.47 5.18 5.7.62-4.24 3.85 1.16 5.6L10 14.1l-5.09 2.75 1.16-5.6L1.83 7.4l5.7-.62L10 1.6z"
      fill={filled ? "currentColor" : "var(--border-strong)"}
    />
  </svg>
);

export function Stars({ value, count = 5 }: { value: number | null; count?: number }) {
  const v = value ?? 0;
  return (
    <span className="stars" role="img" aria-label={value == null ? "no rating" : `${value} out of 5`}>
      {Array.from({ length: count }, (_, i) => (
        <Star key={i} filled={i < Math.round(v)} />
      ))}
    </span>
  );
}
